module.exports = __webpack_public_path__ + "static/img/personal-scan-left.ceb755e7.jpg";